export default __webpack_public_path__ + "static/media/3422.f558a072.png";